import { initialState, State } from 'mk2/apps/strollers/containers/Brands/Brands.reducers';
import { AppState } from 'mk2/reducers';

export const getStrollerBrandsState = (state: AppState): State =>
    state.containers.strollers.brands || initialState;
